module.exports = __webpack_public_path__ + "static/media/bg1.8e27e8bd.jpg";